import "./SupplierPortal.module.css";
import Header from "@/reusable_sections/Header";
import AboutDigitalBridge from "./sections/AboutDigitalBridge";
import WhyChooseUs from "./sections/WhyChooseUs";
import RequestAccessForm from "./sections/RequestAccessForm";
import Footer from "@/reusable_sections/Footer";
export default function SupplierPortalPage() {
  return <div>
      <Header />
      <AboutDigitalBridge />
      <WhyChooseUs />
      <RequestAccessForm />
      <Footer />
    </div>;
}